import { useNavigate } from "react-router-dom";
import { Clock, Boxes, Shield, FileText, LayoutDashboard } from "lucide-react";
import { readRecents } from "@/lib/recents";

// PATCH 36 Me2 — a short recently-viewed quick-access list for both dashboards.
const ICON = { connector: Boxes, admin: Shield, doc: FileText, screen: LayoutDashboard };

export default function RecentActivity({ limit = 6, testid = "recent-activity" }) {
  const nav = useNavigate();
  const items = readRecents().slice(0, limit);
  if (!items.length) return null;
  return (
    <div data-testid={testid} style={{ marginBottom: 14 }}>
      <div className="k-muted" style={{ fontSize: 11, display: "flex", alignItems: "center", gap: 6, padding: "0 4px 6px" }}>
        <Clock size={12} /> Recently viewed
      </div>
      <div style={{ display: "grid", gap: 2 }}>
        {items.map((it) => {
          const Icon = ICON[it.type] || Clock;
          return (
            <button key={it.type + it.to} className="k-link" data-testid={`recent-${it.id}`}
              onClick={() => nav(it.to)}
              style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", textAlign: "left",
                fontSize: 12, borderRadius: 8, width: "100%" }}>
              <Icon size={12} className="k-muted" />
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
